import {Subject} from 'rxjs/Subject';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import * as config from "../../../../config.json";
@Injectable()
export class AuthService {

    constructor(private _http:HttpClient){}

    authenticated = false;
    hostUrl = config['serverUrl']
    authenticationChanged = new Subject<boolean>();
    userId: any;

    register(body:any){

        return this._http.post(this.hostUrl+'/register',body,{
            observe:'body',
            headers:new HttpHeaders().append('Content-Type','application/json')
        });
    }

    login(body: any) {
        return this._http.post(this.hostUrl+'/login', body, {
            observe: 'body',
            withCredentials: true,
            headers: new HttpHeaders().append('Content-Type', 'application/json')
        })
    }

    user() {
        return this._http.get(this.hostUrl+'/user', {
            observe: 'body',
            withCredentials: true,
            headers: new HttpHeaders().append('Content-Type', 'application/json')
        })
    }

    logout() {
        this._http.get(this.hostUrl+'/users/logout',{
            observe:'body',
            withCredentials:true,
            headers:new HttpHeaders().append('Content-Type','application/json')
        });

        this.authenticated = false;
        this.authenticationChanged.next(this.authenticated);
        localStorage.clear();
    }

    loggedIn(){
        this.authenticated = true;
        this.authenticationChanged.next(this.authenticated);
        return !!localStorage.getItem('token')
    }

    getToken(){

        return localStorage.getItem('token');
    }

    isAuthenticated() {
        return this.authenticated;
    }

    setUserId(userId: any) {
        this.userId = userId;
    }

    getUserId(): any {
        return this.userId;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/auth/auth.service.ts